import { useState } from "react";
import "./Home.css";

import testi from "../../assets/images/testi-1.png";
import testi2 from "../../assets/images/testi2.png";
import testi3 from "../../assets/images/testi3.png";

import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import TestimonialCard from "./TestimonialCard";

import VideoModal from "./VideoModal";

const testimonialsStatic = [
  {
    id: 1,
    name: "Vimla Sharma",
    image: testi,
    videoId: "aqz-KE-bpKQ",
  },
  {
    id: 2,
    name: "Surbhi Rawat & Pawan Rawat",
    image: testi2,
    videoId: "ScMzIvxBSi4",
  },
  {
    id: 3,
    name: "Monika Sharma",
    image: testi3,
    videoId: "ysz5S6PUM-U",
  },
  {
    id: 3,
    name: "Monika Sharma",
    image: testi,
    videoId: "ysz5S6PUM-U",
  },
];

const getYoutubeId = (url) => {
  if (!url) return "";
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : url;
};

function Testimonial({ testimonials = [] }) {
  const displayTestimonials = testimonials.length > 0 ? testimonials.map(t => ({
    id: t.patients_id,
    name: t.patients_name,
    image: t.patients_image,
    videoId: getYoutubeId(t.patients_video_link)
  })) : testimonialsStatic;
  const [show, setShow] = useState(false);

  const [videoId, setVideoId] = useState("");

  const openVideo = (id) => {
    setVideoId(id);
    setShow(true);
  };

  const closeVideo = () => {
    setShow(false);
    setVideoId("");
  };

  return (
    <div className="testimonial_section">
      <div className="container-fluid">
        <div className="section_heading  row text-center">
          <div className="content_part col-lg-12 col-sm-12 col-12">
            <h3>
              What <span>Patients Say</span> About Us
            </h3>
            <p>
              Compassionate nursing care, physiotherapy, and bedside assistance
              tailored for patient comfort, recovery, and daily healthcare
              support.
            </p>
          </div>
        </div>
        <div className="testimonial-wrapper">
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={20}
            slidesPerView={3}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            }}
          >
            {displayTestimonials.map((item) => (
              <SwiperSlide key={item.id}>
                <TestimonialCard item={item} onPlay={openVideo} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <VideoModal show={show} handleClose={closeVideo} videoId={videoId} />
      </div>
   
    </div>
  );
}

export default Testimonial;
